import React, { useState, useEffect } from 'react';
import * as qf from '../misc/qf';

const DownloadMediaBtn = ({ media, el }) => {
  const [showDownloadBtn, setShowDownloadBtn] = useState(false);
  const [contextLinks, setContextLinks] = useState(undefined);

  useEffect( () => {
    qf.getJSON(media._links.context_actions.href)
      .then( res => {
        if (!res._links.download) {
          el.remove();
        } else {
          setContextLinks(res);
          setShowDownloadBtn(true);
        }
      })
      .catch( err => console.error(err));
  }, [])

  if (!showDownloadBtn) return (<></>);

  return (
    <a href={contextLinks._links.download.href} download>
      <i className="fa fa-cloud-download"></i> Download
    </a>
  )
}

export default DownloadMediaBtn;
